var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.925537,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#9A85FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 25.9255C28.5 24.8209 29.3954 23.9255 30.5 23.9255C32.7091 23.9255 34.5 25.7164 34.5 27.9255C34.5 30.1346 32.7091 31.9255 30.5 31.9255C29.3954 31.9255 28.5 31.0301 28.5 29.9255V25.9255Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 25.9255C22.5 24.8209 21.6046 23.9255 20.5 23.9255C18.2909 23.9255 16.5 25.7164 16.5 27.9255C16.5 30.1346 18.2909 31.9255 20.5 31.9255C21.6046 31.9255 22.5 31.0301 22.5 29.9255V25.9255Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 27.9255V24.9255C16.5 19.955 20.5294 15.9255 25.5 15.9255C30.4706 15.9255 34.5 19.955 34.5 24.9255V29.7717C34.5 31.78 34.5 32.7841 34.1476 33.5672C33.7465 34.4584 33.0329 35.172 32.1417 35.5731C31.3586 35.9255 30.3545 35.9255 28.3462 35.9255H25.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.373fcc7b5bd9eced131139d52cf1cbd2.svg";
export { ForwardRef as ReactComponent };